import axios from "~/config/axios";
import * as settings from "~/settings";

export async function createFreePurchase(data, onPurchase) {
  const response = await axios.post("/createFreePurchase", {
    source: "obby",
    isFree: true,
    ...data
  });
  let { purchase, purchaseID } = response.data;

  onPurchase && (await onPurchase(purchase));
  // redirect the user to create the booking and redirect to classroom
  window.location.href = `${settings.urls.api}postStripePurchase?purchase_id=${purchaseID}`;
}
